// 一覧 index は単一 target スコープ(target 未指定だと本人分しか返らない)。
// 本人+メンバー分を対象者ごとに並列取得した結果を重複排除して 1 つにまとめる。先に現れたものを優先する。
// 既定キーは id。ただし id が対象者横断で共有される資源(診察券は id=store id で、本人と
// メンバーが同一医院に登録すると同じ id になる)は keyOf で所有者を含めたキーを渡し、別対象者の
// カードが誤って畳まれて消えるのを防ぐ。
export const mergeById = <T extends { id: number }>(
  lists: T[][],
  keyOf: (item: T) => string | number = (item) => item.id
): T[] => {
  const seen = new Set<string | number>()
  const merged: T[] = []
  for (const list of lists) {
    for (const item of list) {
      const key = keyOf(item)
      if (seen.has(key)) continue
      seen.add(key)
      merged.push(item)
    }
  }
  return merged
}
